import { useEffect, useMemo, useState } from "react"

import babylon from "prettier/parser-babel"
import html from "prettier/parser-html"
import postcss from "prettier/parser-postcss"
import typescript from "prettier/parser-typescript"
import { format } from "prettier/standalone"

const usePrettier = (code, type, printWidth, tabSize, lang) => {
  const [prettifiedCode, setPrettifiedCode] = useState(code)
  const [error, setError] = useState("")
  const languages = useMemo(
    () => [
      "tsx",
      "javascript",
      "typescript",
      "jsx",
      "coffescript",
      "script",
    ],
    []
  )
  useEffect(() => {
    try {
      setError("")
      const formattedCode = format(code, {
        parser:
          type !== null
            ? type
            : lang === "json"
            ? `${lang}5`
            : languages.includes(lang)
            ? "typescript"
            : "babel",
        plugins: [babylon, typescript, postcss, html],
        jsxSingleQuote: true,
        printWidth,
        tabWidth: tabSize,
      })
      setPrettifiedCode(formattedCode)
    } catch (error) {
      setPrettifiedCode(code)
      setError(error)
    }
  }, [type, code, printWidth, tabSize, lang, languages])

  return [prettifiedCode, error]
}

export default usePrettier
